<div class="priceListLanding">
  <div class="nplLanding priceList-wrapper" style="width: 100%; margin:0;">
    <div class="priceListLandingPage  margin-0">
      <div class="topSection">

        <div class="alignTopSec relative">
          <div class="row">
            <div class="col">
              <div class="order-view-sec breadcrumbOuter padding-0 " id="orderView1">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item active">
                      <a href="javascript:void(0)" routerLink="/cpp/customer-price-list">Price Lists</a>
                      <i class="fas fa-angle-right"></i>
                    </li>
                    <li class="breadcrumb-item breadcrumbColor">
                      <span>{{accountName}}</span>
                    </li>
                    <li class="breadcrumb-item breadcrumbColor margin-l-rem">
                      <i class="fas fa-angle-right"></i>
                    </li>
                    <li class="breadcrumb-item breadcrumbColor">
                      <span>Products</span>
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div class="xs-pr-15 text-right">
              <div class="subscribe-sec">
                <span class="manage-subs" *ngIf="isManageSubAccess">
                  <i class="fa fa-envelope" aria-hidden="true"></i>
                  <a href="Javascript:void(0);" class="" (click)="redirectToSubscription()">Manage Subscriptions</a>
                </span>
                <div class="status">
                  My Status
                  <span *ngIf="isStatus == 'Subscribed'" class="" (click)="showHideSubscription()">{{ this.isStatus }}</span>
                  <span *ngIf="isStatus != 'Subscribed'" class="redColor" (click)="showHideSubscription()">{{ this.isStatus }}</span>
                </div>
                <div class="tab-content" *ngIf="isSubsModalShow" appClickOutside (clickOutside)="closePopup()">
                  <div class="salesPersonOuter" [ngStyle]="{'width':changesOnly === 'Y' ? '1000px' : '500px' }">
                    <div class="tab-content-heading headtabPadding">
                      For: {{this.accountName}}
                    </div>
                    <div class="tab-content-detail">
                      <p>
                        Do you want to
                        <span *ngIf="isStatus == 'Subscribed'" class="redColor"> Update </span>
                        <span *ngIf="isStatus != 'Subscribed'" class="otherColor"> Subscribe </span>
                        {{isStatus == 'Subscribed' ? "your subscription preferences?": "to this price list?"}}
                      </p>
                      <div class="displayInline">
                        <div class="showChangesSection width-switch1 option">
                          <div class="row">
                            <div [ngClass]="changesOnly === 'Y' ? 'col-3': 'col-6'" class="padding-r0">
                              <div class="row">
                                <div class="col-8">SHOW CHANGES ONLY: <b> {{ changesOnly === "Y" ? "ON" : "OFF" }}</b> </div>
                                <label class="switch">
                                  <input type="checkbox" (click)="toggleForchangesOnlyPopup()" [checked]="changesOnly == 'Y'">
                                  <span class="slider round"></span>
                                </label>
                              </div>
                            </div>
                            <div class="col-5" *ngIf="changesOnly == 'Y' ? true : false">
                              <div class="row">
                                <div class="col-6">
                                  <div class="row">
                                    <div class="col-8 padding-r0">TERM CHANGES ONLY: <b> {{ termchangesOnly === "Y" ? "ON" : "OFF" }}</b> </div>
                                    <label class="switch">
                                      <input type="checkbox" (click)="toggleForTermChangesOnly()" [checked]="termchangesOnly=='Y'">
                                      <span class="slider round"></span>
                                    </label>
                                  </div>
                                </div>

                                <div class="col-6">
                                  <div class="row">

                                    <span class="col-8 padding-r0">PRICE CHANGES ONLY: <b> {{ pricechangesOnly === "Y" ? "ON" : "OFF" }}</b> </span>
                                    <label class="switch">
                                      <input type="checkbox" (click)="toggleForPriceChangesOnlyPopup()" [checked]="pricechangesOnly=='Y'">
                                      <span class="slider round"></span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="headerCompany !== masterConstants.US_COMPANYCODE" class="col-4">
                              <div class="row">
                                <div class="col-8">DISPLAY: <b> {{ subscriptionType === "C" ? "SPECIAL PRICED ITEMS" : "ALL ITEMS" }}</b> </div>
                                <label class="switch">
                                  <input type="checkbox" (click)="toggleForSpecialItemDisplayPopup()" [checked]="subscriptionType == 'C'">
                                  <span class="slider round"></span>
                                </label>
                              </div>
                            </div>
                            <div *ngIf="headerCompany === masterConstants.US_COMPANYCODE" class="padding-r0" [ngClass]="changesOnly === 'Y' ? 'col-4': 'col-6'">
                              <div class="row">

                                <div class="col-8">
                                  DISPLAY: <b>
                                    {{subscriptionType === "A" ? "ALL ITEMS" : subscriptionType === "F" ? "FAVORITE ITEMS" : subscriptionType === "C" ? "SPECIAL PRICED ITEMS" : "UNKNOWN SUBSCRIPTION TYPE" }}
                                  </b>
                                </div>
                                <div class="switch" [id]="mySubscriptionDisplayItemToggle">
                                  <mat-slide-toggle class="example-margin" (click)="changeForMySubscription()">
                                  </mat-slide-toggle>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="displayInline row">
                        <div class="allItemsSection width-switch3 option" [ngClass]="changesOnly === 'Y' ? 'col-3': 'col-4'">
                          <div class="row">
                            <div class="col-8">DISPLAY APR: <b> {{ displayAPR === "Y" ? "ON" : "OFF" }}</b> </div>
                            <label class="switch position-switch3">
                              <input type="checkbox" (click)="toggleForDisplayAPRPopup()" [checked]="displayAPR == 'Y'">
                              <span class="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="btn-sec margin-t20">
                        <button mat-raised-button class="btns normal-large-btn margin-r15" (click)="isStatus == 'Subscribed' ? changeStatus(true): changeStatus();" color="primary"> {{isStatus == 'Subscribed' ? "Update": "Subscribe"}}</button>
                        <button mat-raised-button class="btns normal-large-btn" (click)="closePopup()" color="primary">Cancel</button>
                        <button *ngIf="isStatus == 'Subscribed'" mat-raised-button class="btns normal-large-btn xs-ml-15" (click)="changeStatus();" color="primary">Unsubscribe</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-sec">
                <div class="row margin-b10 margin-r0 margin-l0 ">
                  <div class="col-md-12 col-lg-12 smallPadRgt0 padding-l0">
                    <div class="row search-box-outer ">
                      <div class="col-md-3 col-lg-2 padding-r0 catgory-drop-outer">
                        <div class="category-dropdown material-select">
                          <ng-select [items]="searchTypeList"
                                     name="ddlProductSearch"
                                     [(ngModel)]="selectedValue"
                                     [virtualScroll]="true"
                                     [closeOnSelect]="true"
                                     [selectOnTab]="true"
                                     [clearable]="false"
                                     bindValue="value"
                                     labelForId="name"
                                     [searchable]="false"
                                     (change)="retainFilter(null, ' '); setChangeSinceDate();">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-md-7 col-lg-8 borderLeft padding-l4 padding-r0 searchRtSection">
                        <div class="row material-select reports-search-filter">

                          <ng-select #productCategory name="ddlproductSearch" *ngIf="selectedValue === 'Product Category'"
                                     [items]="priceListFilter.productCategory"
                                     placeholder="Search Products"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.productCategory"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="retainFilter(productCategory, 'Product Category');">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <ng-select #productLine name="ddlproductSearch" *ngIf="selectedValue === 'Product Line'"
                                     [items]="priceListFilter.productLine"
                                     placeholder="Search Products"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.productLine"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="retainFilter(productLine, 'Product Line')">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <ng-select #packageSize *ngIf="selectedValue=='Pack Size'"
                                     name="ddlPSSearch"
                                     placeholder="Search Products"
                                     class="custom-select-grower"
                                     [items]="priceListFilter.packageSize"
                                     [(ngModel)]="productFilters.packageSize"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="id"
                                     [closeOnSelect]="true"
                                     (change)="retainFilter(packageSize, 'Pack Size')">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for ""
                              </div>
                            </ng-template>
                          </ng-select>

                          <ng-select #productNumber name="ddlproductSearch" *ngIf="selectedValue === 'Product Number'"
                                     [items]="priceListFilter.productNumber"
                                     placeholder="Search Products"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.productNumber"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="retainFilter(productNumber, 'Product Number');">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <ng-select #productSupplier name="ddlproductSearch" *ngIf="selectedValue === 'Supplier'"
                                     [items]="priceListFilter.supplier"
                                     placeholder="Search Products"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.supplier"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="retainFilter(productSupplier, 'Supplier');">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="selectedValue === 'Change Since'" class="datepicker-wrapper">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <mat-form-field [floatLabel]="'never'" class="example-full-width">
                              <!--<mat-label>Select or Enter date in mm/dd/yyyy</mat-label>-->
                              <input matInput #pickerInput [matDatepicker]="picker" placeholder="Select or Enter date in mm/dd/yyyy" [max]="maxDate" (keypress)="validateDateString($event)" (focus)="picker.open();"
                                     [(ngModel)]="priceListFilter.changeSinceDate" [matDatepickerFilter]="dateFilter">
                              <mat-datepicker-toggle matSuffix [for]="picker">
                                <i class="fa fa-chevron-down" matDatepickerToggleIcon></i>
                              </mat-datepicker-toggle>
                              <mat-datepicker [startAt]="startDate" #picker [dateClass]="dateClass"></mat-datepicker>
                              <mat-error>{{getErrorMessage(pickerInput.value)}}</mat-error>
                            </mat-form-field>
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </div>
                          <ng-select #productBrand name="ddlproductSearch" *ngIf="selectedValue === 'Product Brand'"
                                     [items]="priceListFilter.productBrand"
                                     placeholder="Search Products"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.productBrand"
                                     [virtualScroll]="true"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="retainFilter(productBrand, 'Product Brand');">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                          <ng-container *ngTemplateOutlet="tmplInputTime; context: { value:productFilters}"></ng-container>
                        </div>
                      </div>
                      <div class="col-md-2 col-lg-2 search-btn-outer text-right padding-0">
                        <div class="search-btn">
                          <button mat-raised-button class="btns" [disabled]="disableFilterBtn" (click)="retainFilter(null, ' ');getCPPProductData();" color="primary">Filter</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="chips-sec">
                      <div class="row selected-chip">
                        <div class="col-md-10 col-lg-10 padding-l0 padding-r0">
                          <div *ngIf="viewAllFilters || filterValueList.length <=8;else viewAll">
                            <mat-chip-set>
                              <mat-chip selected *ngFor="let filterValue of filterValueList" [removable]="true" (mouseup)="removeSelectedFilter(filterValue);getCPPProductData();">
                                {{filterValue}}
                                <a href="Javascript:void(0);" (click)="clearFilter(filterValue);">
                                  <i class="fas fa-times text-right"></i>
                                </a>
                              </mat-chip>
                              <a *ngIf="viewAllFilters" href="Javascript:void(0);" class="clearAll showHidetxt" (click)="viewAllFilter()">{{displayHideAll?"Hide All Applied Filters":""}}</a>
                            </mat-chip-set>
                          </div>
                          <ng-template #viewAll>
                            <div *ngIf="filterValueList.length >8">
                              <span class="filter-text"><span class="numberCircle totalNoFilter">{{filterValueList.length}}</span>Filters Applied</span>
                              <a href="Javascript:void(0);" class="clearAll showHidetxt" (click)="viewAllFilter()">View All Applied Filters</a>
                            </div>
                          </ng-template>
                        </div>
                        <div class="col-md-2 col-lg-2 text-right padding-r30" *ngIf="filterValueList.length > 0">
                          <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row padding-r15 topSecBtn">
                  <div class="col-3  padding-l0">
                    <div class=" listing-action-items">
                      <div class="selectAllcheckSec" *ngIf="cppProductListDataSource">
                        <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                                      [checked]="cppProductListDataSource.data.length > 0 && (selectedCount > 0) && (selectedCount == cppProductListDataSource.data.length)"
                                      [indeterminate]="cppProductListDataSource.data.length > 0 && (selectedCount > 0) && (selectedCount < cppProductListDataSource.data.length)"
                                      [style.display]="'block'"
                                      (change)="enableAllCheckBoxes(Allcheck._checked);"
                                      matTooltip="Select All Lines" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp"></mat-checkbox>

                        <i class="fas fa-sort-down light-gray-arrow" aria-hidden="true"></i>
                      </div>

                      <div class="action-links display-ib" *ngIf="editToolKit">
                        <div class="display-ib">

                          <span *ngIf="headerCompany === masterConstants.US_COMPANYCODE" class="margin-l5 circular-btn firstOne" mat-button [matMenuTriggerFor]="beforeEmail" matTooltip="Email Selected Products" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                            <i class="fas fa-envelope"></i>
                            <mat-menu #beforeEmail="matMenu" xPosition="after" class="context-meun-dropdown">
                              <button mat-menu-item (click)="emailData(true, false)">Email with APR</button>
                              <button mat-menu-item (click)="emailData(false, false)">Email without APR</button>
                              <button *ngIf="isOwnerPriceListAccess==='Y'" mat-menu-item (click)="emailData(true, true)">Email owner pricing with APR</button>
                              <button *ngIf="isOwnerPriceListAccess==='Y'" mat-menu-item (click)="emailData(false, true)">Email owner pricing without APR</button>
                            </mat-menu>
                          </span>

                          <span *ngIf="headerCompany === masterConstants.US_COMPANYCODE" class="margin-l5 circular-btn thirdOne context-menu" mat-button [matMenuTriggerFor]="beforeMenu1" matTooltip="Export Selected Products" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                            <i class="fas fa-download"></i>
                            <mat-menu #beforeMenu1="matMenu" xPosition="after" class="context-meun-dropdown">
                              <button mat-menu-item (click)="exportData(true, false)">Export spreadsheet with APR</button>
                              <button mat-menu-item (click)="exportData(false,false)">Export spreadsheet without APR</button>
                              <button *ngIf="isOwnerPriceListAccess==='Y'" mat-menu-item (click)="exportData(true, true)">Export owner pricing with APR</button>
                              <button *ngIf="isOwnerPriceListAccess==='Y'" mat-menu-item (click)="exportData(false, true)">Export owner pricing without APR</button>
                            </mat-menu>
                          </span>

                          <span *ngIf="headerCompany === masterConstants.US_COMPANYCODE" matTooltip="Add Selected Item to Favorites" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" style="padding: 22px 1px 0px 2px;">
                            <i class="favourite-add" (click)="AddFavorite()"></i>
                          </span>

                          <span *ngIf="headerCompany === masterConstants.US_COMPANYCODE" matTooltip="Remove Selected Item from Favorites" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" style="padding: 22px 1px 0px 2px;">
                            <i class="favourite-remove" (click)="RemoveFavorite()"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-9 text-right padding-b10 toggleSection padding-0 margin-r-10 margin-t-10">

                    <div class="showChangesSectionDisplay">
                      <div class="toggleColor row">
                        <!--<div [ngClass]="isShowChangesOnly ? '' :'col-md-2'"></div>-->
                        <div [ngClass]="isShowChangesOnly ? 'col-3' :'col-3'" class="padding-l0 padding-r0">
                          <span class="padding-r10">SHOW CHANGES ONLY: <b> {{isShowChangesOnly?"ON":"OFF"}}</b> </span>
                          <label class="switch">
                            <input type="checkbox" (click)="toggleShowChangesOnly()" [checked]="isShowChangesOnly">
                            <span class="slider round"></span>
                          </label>
                        </div>

                        <div class="col-6 padding-l0 padding-r0" *ngIf="isShowChangesOnly">
                          <span class="padding-r10">TERM CHANGES ONLY: <b> {{isTermChangeOnly?"ON":"OFF"}}</b></span>
                          <label class="switch">
                            <input type="checkbox" checked>
                            <span class="slider round" (click)="filterDataForTermChangeOnly()" checked="isTermChangeOnly"></span>
                          </label>
                          <span class="padding-r10 padding-l20">PRICE CHANGES ONLY: <b> {{isPriceChangeOnly?"ON":"OFF"}}</b></span>
                          <label class="switch">
                            <input type="checkbox" checked>
                            <span class="slider round" (click)="filterDataForPriceChangeOnly()" checked="isPriceChangeOnly"></span>
                          </label>
                        </div>

                        <div *ngIf="headerCompany !== masterConstants.US_COMPANYCODE" [ngClass]="isShowChangesOnly ? 'col-3' :'col-3'" class=" padding-l0 padding-r0">
                          <span class="padding-r10">DISPLAY: <b> {{isSpecialPriceListDisplayed?"SPECIAL PRICED ITEMS":"ALL ITEMS"}}</b> </span>
                          <label class="switch">
                            <input type="checkbox" checked>
                            <span class="slider round" (click)="toggleSpecialItemDisplay()" checked="false"></span>
                          </label>
                        </div>

                        <div *ngIf="headerCompany === masterConstants.US_COMPANYCODE" [ngClass]="isShowChangesOnly ? 'col-3' :'col-3'" class=" padding-l0 padding-r0">
                          <span class="padding-r10 align-top">DISPLAY: <b> {{displayText}}</b> </span>
                          <section class="display-ib" [id]="displayItem">
                            <mat-slide-toggle class="example-margin" (click)="triToggleSpecialItemDisplay()">
                            </mat-slide-toggle>
                          </section>
                        </div>

                        <div *ngIf="headerCompany === masterConstants.US_COMPANYCODE" [ngClass]="isShowChangesOnly ? 'col-3' :'col-3'" class=" padding-l0 padding-r0">
                          <span class="padding-r10">
                            DISPLAY: <b>{{isPriceListDisplayed?"APR PRICING":"NON-APR PRICING"}}</b>
                          </span>
                          <label class="switch">
                            <input type="checkbox" checked>
                            <span class="slider round" (click)="toggleDisplay()"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="padding-b10  margin-t10 col-4">

                    <div *ngIf="priceChangeCount>0 && isSpecialPriceListDisplayed==false"><span class=" padding-r10" *ngIf="priceChangeCount>0"><b>PRICING/TERM CHANGES: </b></span><span class="numberCircle padding-b6 "><b>{{priceChangeCount}}</b></span></div>
                    <div *ngIf="priceChangeCountCustomerSpecific>0 && isSpecialPriceListDisplayed==true"><span class=" padding-r10" *ngIf="priceChangeCountCustomerSpecific>0"><b>PRICING/TERM CHANGES: </b></span><span class="numberCircle padding-b6 "><b>{{priceChangeCountCustomerSpecific}}</b></span></div>
                  </div>
                  <div class="col-5">
                  </div>
                  <div class="paginationSection col-3">
                    <mat-paginator #productListPaginator [pageSize]="250" (page)="updatePage($event)"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomSection pt-0">
        <div class="py-1">
          <h5 *ngIf="headerCompany === masterConstants.US_COMPANYCODE" class="text-center price-disclaimer">Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily.</h5>
        </div>

        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer priceListTable" id="cppOrderView">
              <table mat-table #placedCPPOrdersTable [dataSource]="cppProductListDataSource" multiTemplateDataRows class="matTables">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of priceListCPPColumns">
                  <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
            </div>
            <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product </th></div>
            <div *ngIf="isPriceListDisplayed  && column=='priceChange'"><th mat-header-cell *matHeaderCellDef class="pricingChange">&nbsp;</th></div>
            <div *ngIf="column=='terms'"><th mat-header-cell *matHeaderCellDef class="termsCol text-center">{{isPriceListDisplayed == false ? '' : 'Terms'}}</th></div>
            <div *ngIf="column=='dec'"><th mat-header-cell *matHeaderCellDef class="package text-center">{{isPriceListDisplayed == false ? '' : 'Dec'}}</th></div>
            <div *ngIf="column=='jan'"><th mat-header-cell *matHeaderCellDef class="package text-center">{{isPriceListDisplayed == false ? '' : 'Jan'}}</th></div>
            <div *ngIf="column=='feb'"><th mat-header-cell *matHeaderCellDef class="package text-center">{{isPriceListDisplayed == false ? '' : 'Feb'}}</th></div>
            <div *ngIf="column=='mar'"><th mat-header-cell *matHeaderCellDef class="package text-center">{{isPriceListDisplayed == false ? '' : 'Mar'}}</th></div>
            <div *ngIf="column=='apr'"><th mat-header-cell *matHeaderCellDef class="package text-center">{{isPriceListDisplayed == false ? '' : 'Apr'}}</th></div>
            <div *ngIf="column=='may'"><th mat-header-cell *matHeaderCellDef class="package text-center">{{isPriceListDisplayed == false ? '' : 'May'}}</th></div>
            <div *ngIf="isPriceListDisplayed == false && column=='priceChange2'"><th mat-header-cell *matHeaderCellDef class="pricingChange">&nbsp;</th></div>
            <div *ngIf="column=='price'"><th mat-header-cell *matHeaderCellDef class="package text-right">{{isPriceListDisplayed == false ? 'Your Price' : 'Base Price'}}</th></div>
            <div *ngIf="column=='contextMenu'"><th mat-header-cell *matHeaderCellDef class="detailsTable text-center"></th></div>

            <td mat-cell *matCellDef="let element">
              <div *ngIf="column=='checkbox' && element.isGroup === false" class="text-center CheckBoxCol"
                   (click)="showDetails($event, element,column)"
                   matTooltip="Select Product" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                <mat-checkbox #SingleCheck class="custom-checkbox"
                              [style.display]="'contents'"
                              (change)="enableCheckBoxSingle(SingleCheck._checked); element.isSelected=SingleCheck._checked;"
                              [(ngModel)]="element.isSelected"></mat-checkbox>

                <span *ngIf="element.isFavoriteItem && headerCompany === masterConstants.US_COMPANYCODE" class="favIcon" (click)="RemoveFavoriteIndividual(element)"> <i class="fas fa-star"></i></span>
                <span *ngIf="!element.isFavoriteItem && headerCompany === masterConstants.US_COMPANYCODE" class="favIcon" (click)="AddFavoriteIndividual(element)"> <i class="far fa-star"></i></span>
              </div>
              <div *ngIf="column=='product'">
                <div class="order-info">
                  <div class="grower-name" *ngIf="element.isGroup && headerCompany === masterConstants.US_COMPANYCODE">
                    {{element.isGroup ? element.hvDesc:element.supplier}}
                    <span class="restrictedStyle" *ngIf="element.isGroup === true && (element.rup === 'Y')">RESTRICTED</span>
                  </div>
                  <p class="itemName">
                    <span>{{element.prodDesc}}</span>
                  </p>
                </div>
              </div>

              <div *ngIf="column=='priceChange2' && isPriceListDisplayed === false  " class="showHideDetails text-center">

                <div matTooltip="{{element.toolTip.join('&#13;')}}" [matTooltipPosition]="'above'" matTooltipClass="greyBgCpp"
                     *ngIf="(element.priceFlag === 'Y' || element.termFlag === 'Y' || element.rplPriceFlag === 'Y' || element.rplTermFlag === 'Y' || element.nplPriceFlag === 'Y' || element.nplTermFlag === 'Y') && element.isGroup===false &&  isPriceListDisplayed === false" class="numberCircle rowPricingChanges">
                  <b *ngIf="element.priceFlagCount > 0">{{element.priceFlagCount}}</b>
                </div>
              </div>

              <div *ngIf="column=='price'" class="showHideDetails text-right">
                <span class="prod-total-price padding-b0"
                      [ngClass]="{'pricing-uom':element.isGroup && headerCompany === masterConstants.US_COMPANYCODE}">
                  <ng-container *ngIf="isPriceListDisplayed == false && headerCompany === masterConstants.US_COMPANYCODE;else june">
                    {{element.isGroup ? 'PER '+element.pricingUom : element.basePrice | currency :element.cur:'symbol':'1.4-4'}}
                  </ng-container>
                  <ng-template #june>
                    {{
                      (element.isGroup ? 'PER '+element.pricingUom : element.basePrice | currency :element.cur:'symbol': masterConstants.NUMBER_FORMAT)
                    }}
                  </ng-template>
                </span>
              </div>
              <div *ngIf="column=='contextMenu' && element.isGroup === false">
                <button id="btn_{{element.rowNo}}" mat-button (click)="showProductDetails(element, this);" class="context-menu" disableRipple>
                  <i class="fas fa-ellipsis-v margin-l15"></i>
                </button>

                <!--</div>-->
              </div>
              <ng-container *ngIf="isPriceListDisplayed">

                <div *ngIf="column=='priceChange' && isPriceListDisplayed" class="showHideDetails text-center">

                  <div matTooltip="{{element.toolTip.join('&#13;')}}" [matTooltipPosition]="'above'" matTooltipClass="greyBgCpp"
                       *ngIf="(element.priceFlag === 'Y' || element.termFlag === 'Y' || element.rplPriceFlag === 'Y' || element.rplTermFlag === 'Y' || element.nplPriceFlag === 'Y' || element.nplTermFlag === 'Y') && element.isGroup===false && isPriceListDisplayed === true"
                       class="numberCircle rowPricingChanges"><b *ngIf="element.priceFlagCount > 0">{{element.priceFlagCount}}</b></div>
                </div>
                <div *ngIf="column=='terms'  " class="showHideDetails text-center">
                  <span class="advance-price-col">
                    {{element.ptDesc}}
                  </span>
                </div>
                <div *ngIf="column=='dec'" class="showHideDetails text-center">
                  <span class="advance-price-col">
                    {{element.dec | currency :element.cur :'symbol':'1.4-4'}}
                  </span>
                </div>
                <div *ngIf="column=='jan'   " class="showHideDetails text-center">
                  <span class="advance-price-col">
                    {{element.jan | currency :element.cur:'symbol':'1.4-4'}}
                  </span>
                </div>
                <div *ngIf="column=='feb'   " class="showHideDetails text-center">
                  <span class="advance-price-col">
                    {{element.feb | currency :element.cur:'symbol':'1.4-4'}}
                  </span>
                </div>
                <div *ngIf="column=='mar'   " class="showHideDetails text-center">
                  <span class="advance-price-col">
                    {{element.mar | currency :element.cur:'symbol':'1.4-4'}}
                  </span>
                </div>
                <div *ngIf="column=='apr'  " class="showHideDetails text-center">
                  <span class="advance-price-col">
                    {{element.apr | currency :element.cur:'symbol':'1.4-4'}}
                  </span>
                </div>
                <div *ngIf="column=='may'  " class="showHideDetails text-center">
                  <span class="advance-price-col">
                    {{element.may | currency :element.cur:'symbol':'1.4-4'}}
                  </span>
                </div>
                <div *ngIf="column=='june'  " class="showHideDetails text-center">
                  <span class="advance-price-col">
                    {{element.june | currency :element.cur:'symbol':'1.4-4'}}
                  </span>
                </div>
              </ng-container>
            </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="priceListCPPColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: priceListCPPColumns"
                [ngClass]="{'groupName':element.isGroup,
                    'example-element-row':(element.isGroup=== false),
                    'hide-row': (element.hvDesc=== null)}"
                id="tr_exp_{{element.rowNo}}"></tr>
            </table>

            <div *ngIf="cppProductListDataSource == undefined || cppProductListDataSource?.data.length == 0" class="noDataMsg">
              <p>No Product Found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #tmplInputTime let-value="value">
  <div class="wide100" *ngIf="selectedValue == 'Product Name'">
    <div class="search-box-outer">
      <div class="search-box wide100">
        <span class="search-icon">
          <i class="fas fa-search"></i>
        </span>
        <div class="select-container">
          <ng-container *ngIf="selectedValue == 'Product Name'">
            <!--<input (keyup.enter)="retainFilter(null, ' ');getCPPProductData();" [(ngModel)]="productNameInput"
                   placeholder="Search Products" type="text">-->
            <app-typeahead style="top: 7px; left: 42px; position: absolute;width: 100%;" (modelChange)="updatedVal($event); retainFilter(null, ' ');getCPPProductData();" (textLengthDetect)="validateBrand($event)" [listData]="productNameSearchList"></app-typeahead>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
</div>
